var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"b-loading__wrap",staticStyle:{"z-index":"1000"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b-loading"},[_c('img',{attrs:{"src":require("../../../assets/images/Artboard 1_800.jpg"),"alt":"loading_image"}})])
}]

export { render, staticRenderFns }